import { Layout } from "layouts";
import { TermsData } from "@/components/terms";

const TermsAndConditions: React.FC = () => {
  return (
    <Layout page={"terms"}>
      {/* <TermsHero/> */}
      <TermsData heading={""} content={""} />
    </Layout>
  );
};

export default TermsAndConditions;
